import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
const initialState = {
    rooms: [],
    currentRoomId: null,
};
export const useRoomListStore = create()(devtools((set, get) => ({
    ...initialState,
    // Room一覧全体の管理
    setRooms: (rooms) => set({ rooms }),
    resetRooms: () => set({ rooms: [], currentRoomId: null }),
    // 個別Room操作
    addRoom: (room) => set((state) => ({
        rooms: [...state.rooms, room]
    })),
    removeRoom: (roomId) => set((state) => ({
        rooms: state.rooms.filter(room => room.id !== roomId),
        currentRoomId: state.currentRoomId === roomId ? null : state.currentRoomId
    })),
    updateRoom: (roomId, updates) => set((state) => ({
        rooms: state.rooms.map(room => room.id === roomId ? { ...room, ...updates } : room)
    })),
    // 現在のRoom管理
    setCurrentRoomId: (roomId) => set({ currentRoomId: roomId }),
    getCurrentRoom: () => {
        const state = get();
        return state.currentRoomId
            ? state.rooms.find(room => room.id === state.currentRoomId) || null
            : null;
    },
    // 検索・フィルタリング
    findRoomById: (roomId) => {
        const state = get();
        return state.rooms.find(room => room.id === roomId) || null;
    },
    findRoomsByKeyword: (keyword) => {
        const state = get();
        return state.rooms.filter(room => room.keyword && room.keyword.includes(keyword));
    },
    findRoomsByName: (name) => {
        const state = get();
        return state.rooms.filter(room => room.name && room.name.includes(name));
    },
}), {
    name: 'room-list-store',
}));
